// src/components/TopNav.js - Đã sửa lỗi hiển thị menu Trưởng Khối
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import './TopNav.css';

const TopNav = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const catechistFullName = localStorage.getItem('catechistFullName') || 'Giáo lý viên';
  const userRole = localStorage.getItem('userRole') || 'catechist';
  const rawDept = localStorage.getItem('departmentLeader') || '';
  const blockLeader = localStorage.getItem('blockLeader') || '';

  // 🌟 1. Kiểm tra Ban Kỷ Luật & Hành Chánh (Tương thích Array, JSON String & Chuỗi đơn)
  const hasDepartment = (targetDept) => {
    if (!rawDept) return false;
    let depts = rawDept;

    try {
      depts = JSON.parse(rawDept);
    } catch (e) {
      // Chuỗi thường
    }

    if (Array.isArray(depts)) {
      return depts.includes(targetDept);
    }
    if (typeof depts === 'string') {
      return depts.split(',').map((s) => s.trim()).includes(targetDept);
    }
    return false;
  };

  const isDisciplineLeader = hasDepartment('Ban Kỷ Luật');
  const isAdministrativeLeader = hasDepartment('Ban Hành Chánh');
  const isLiturgyLeader = hasDepartment('Ban Phụng Vụ');

  // 🌟 2. Kiểm tra Trưởng Khối linh hoạt (Nhận diện mọi định dạng tên Khối hoặc Admin)
  const isBlockLeader = () => {
    if (userRole === 'admin') return true;
    if (!blockLeader || typeof blockLeader !== 'string') return false;
    const clean = blockLeader.trim().toLowerCase();
    return clean !== '' && clean !== 'không' && clean !== 'none' && clean !== 'null';
  };

  // 2. Thêm hàm điều hướng
  const handleLiturgyBoardClick = () => {
    setIsDropdownOpen(false);
    navigate('/liturgy-board');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.clear();
      navigate('/login');
    } catch (error) {
      console.error('Lỗi khi đăng xuất:', error);
    }
  };

  const handleProfileClick = () => {
    setIsDropdownOpen(false);
    navigate('/main/profile');
  };

  const handleAdminManagementClick = () => {
    setIsDropdownOpen(false);
    navigate('/admin-management');
  };

  const handleDisciplineBoardClick = () => {
    setIsDropdownOpen(false);
    navigate('/discipline-board');
  };

  const handleAdministrativeBoardClick = () => {
    setIsDropdownOpen(false);
    navigate('/administrative-board');
  };

  const handleBlockLeaderManagementClick = () => {
    setIsDropdownOpen(false);
    navigate('/blockleadermanagement');
  };

  const handleHomeClick = () => {
    setIsDropdownOpen(false);
    navigate('/main');
  };

  const handleHomePageClick = () => {
    setIsDropdownOpen(false);
    navigate('/home');
  };

  return (
    <nav className="top-nav">
      <div className="brand-box" onClick={handleHomeClick}>
        <img src="/logo.png" alt="Logo" className="nav-logo" />
        <h1 className="nav-title">Hệ Thống Điểm Danh</h1>
      </div>

      <div className="nav-right" ref={dropdownRef}>
        <div
          className="user-info"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <span className="user-name">{catechistFullName}</span>
          <span className={`arrow ${isDropdownOpen ? 'up' : 'down'}`}>▼</span>
        </div>

        {isDropdownOpen && (
          <div className="dropdown-menu">
            <button onClick={handleHomeClick}>Hệ thống điểm danh</button>

            {userRole === 'admin' && (
              <button onClick={handleAdminManagementClick}>Ban Điều Hành</button>
            )}

            {/* Hiển thị nếu thuộc Ban Kỷ Luật */}
            {isDisciplineLeader && (
              <button onClick={handleDisciplineBoardClick}>Ban Kỷ Luật</button>
            )}

            {/* Hiển thị nếu thuộc Ban Hành Chánh */}
            {isAdministrativeLeader && (
              <button onClick={handleAdministrativeBoardClick}>Ban Hành Chánh</button>
            )}

            {isLiturgyLeader && (
              <button onClick={handleLiturgyBoardClick}>Ban Phụng Vụ</button>
            )}

            {/* Hiển thị nếu là Trưởng Khối hoặc Admin */}
            {isBlockLeader() && (
              <button onClick={handleBlockLeaderManagementClick}>Trưởng Khối Quản Lý</button>
            )}

            <hr />
            <button onClick={handleHomePageClick}>Trang chủ</button>
            <button onClick={handleProfileClick}>Thông tin giáo lý viên</button>
            <button onClick={handleLogout} className="btn-logout">Đăng xuất</button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default TopNav;